// extracted by mini-css-extract-plugin
export default {"wrapper":"OT-z"};